import { useTaskStatusSummary } from "../../Hooks/Features/ProjectDashboard/useTaskStatusSummary";

const ProgressBar = () => {
    const { taskStatus } = useTaskStatusSummary();
    return (
        <div className="w100 d-flex my-2">
            {
                taskStatus?.map((value, index) => {
                    return <div className="text-center py-1" style={{ fontSize: "16px", fontWeight: "500", color: "white", minWidth: "15%", width: value?.width, ...value?.style }} key={index}>
                        <span style={{cursor:"default"}} title={value?.width}>{value?.name} ({value?.count})</span>
                    </div>
                })
            }
        </div>
    )
}

export default ProgressBar